/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import * as Common from '../../../utils/Common'
import api from '../../../config/AxiosInstance'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import { firstLetterUpperCase } from '../../../utils/TextFormatter'
import { convertDateWithTime, transformKey } from '../../../helpers/constants'
import { ChevronDown, ChevronUp, ArrowLeft, Download, Copy } from 'lucide-react'
import { Loader } from 'react-bootstrap-typeahead'
import Loading from '../../../components/atoms/Loading'
import moment from 'moment'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#888',
  textTransform: 'uppercase',
  marginBottom: '0.2rem',
  letterSpacing: '0.5px'
}

const valueStyle = {
  fontSize: '1rem',
  fontWeight: '500',
  color: '#333'
}

function DetailTransferArea() {
  const { id } = useParams()
  const { state } = useLocation()
  const navigate = useNavigate()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingSendToErp, setLoadingSendToErp] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState({})
  const [expand, setExpand] = useState(true)

  const handleDownloadLabel = async (itemId) => {
    try {
      setLoadingDownload((prev) => ({ ...prev, [itemId]: true }))
      const res = await api.get(`transfer/${id}/${itemId}`, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `label_${itemId}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        setTimeout(() => {
          toast.success('Label downloaded!', {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
        }, 1000)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingDownload((prev) => ({ ...prev, [itemId]: false }))
    }
  }

  const renderAction = (data) => (
    <Button
      variant={`${loadingDownload[data.id] ? 'secondary' : 'warning'}`}
      style={{
        cursor: 'pointer'
      }}
      onClick={() => handleDownloadLabel(data.id)}
      disabled={loadingDownload[data.id]}
      size="sm"
    >
      <div className="d-flex flex-row gap-2">
        <div className="d-flex flex-column items-content-center justify-content-center">
          <Download className="text-white" size={14} />
        </div>
      </div>
    </Button>
  )

  const columns = [
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (data) => data.item_code + ' - ' + data.item_name
    },
    {
      key: 'batch',
      label: 'Batch',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data.batch ?? '-'}

          {data.batch && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data.batch)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    { key: 'total_qty', label: 'Base UOM Qty' },
    { key: 'total_pack', label: 'Qty Kemasan' },
    {
      key: 'problem',
      label: 'Problem',
      component: (data) => (data?.problem ? transformKey(data?.problem) : '-')
    },
    {
      key: 'source',
      label: 'Source Slot',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data?.source ?? '-'}

          {data?.source && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data?.source)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    {
      key: 'source_palet',
      label: 'Source Palet',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data?.source_palet ?? '-'}

          {data?.source_palet && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data?.source_palet)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    {
      key: 'destination',
      label: 'Destination Slot',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data?.destination ?? '-'}

          {data?.destination && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data?.destination)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    {
      key: 'destination_palet',
      label: 'Destination Palet',
      component: (data) => (
        <div className="d-flex align-items-center gap-2">
          {data?.destination_palet ?? '-'}

          {data?.destination_palet && (
            <Copy
              size={14}
              className="text-muted cursor-pointer"
              style={{
                cursor: 'pointer',
                opacity: 0.5,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.5)}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigator.clipboard.writeText(data?.destination_palet)
                toast.success('Copied to clipboard')
              }}
              title="Copy"
            />
          )}
        </div>
      )
    },
    { key: 'action', label: 'Label' }
  ]

  const getData = async () => {
    try {
      setLoading(true)
      const response = await api.get(`transfer/${id}`)
      const { data } = response.data
      setData(data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
      navigate(-1)
    } finally {
      setLoading(false)
    }
  }

  const handleRetrySendToErp = async () => {
    try {
      setLoadingSendToErp(true)
      const res = await api.post(`/transfer/${id}/send-erp`)
      const { status, data } = res
      if (status === 200) {
        if (!data?.data?.erp_code) {
          throw new Error(`Sent to ERP failed on ${state?.code || id}`)
        }
        toast.success('Send to erp success', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        getData()
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(err, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      navigate('/transfer/transfer-area', {
        state: {
          warehouse_id: state?.warehouse_id || '',
          start_date: state?.start_date || '',
          end_date: state?.end_date || ''
        }
      })
    } finally {
      setLoadingSendToErp(false)
    }
  }

  useEffect(() => {
    if (id) getData()
  }, [id])

  if (loading) {
    return <Loading />
  }

  return (
    <Container fluid className="px-4 mb-5">
      <Toaster />
      <Row className="mb-4">
        <Col md={12}>
          <div className="d-flex align-items-center gap-2 mb-2">
            <Link
              to="/transfer/transfer-area"
              state={state || {}}
              className="text-decoration-none text-secondary d-flex align-items-center"
            >
              <ArrowLeft size={16} className="me-2" />
              Transfer Area
            </Link>
            <span className="text-muted">/</span>
            <span className="text-dark fw-bold">Detail</span>
          </div>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 style={headerTitleStyle}>Transfer Area Detail</h3>
          </div>
        </Col>
      </Row>

      <Card style={cardStyle}>
        <Row className="mb-4">
          <Col md={6}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Transfer Code</span>
              <div className="d-flex align-items-center gap-2">
                <span
                  style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: 'var(--primary-orange)'
                  }}
                >
                  {state?.code || data?.code || id}
                </span>
                <div style={{ fontSize: '14px' }}>
                  <BadgeStatusPrLists
                    text={
                      data?.transfer_status
                        ? data?.transfer_status.replaceAll('_', ' ')
                        : ''
                    }
                  />
                </div>
              </div>
            </div>
          </Col>
          <Col md={6} className="text-md-end">
            <div className="d-flex flex-column align-items-md-end">
              <span style={labelStyle}>Warehouse</span>
              <span style={valueStyle}>{data?.warehouse || '-'}</span>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={12}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Type</span>
              <span style={valueStyle}>
                {data?.transfer_type
                  ? firstLetterUpperCase(data?.transfer_type)
                  : '-'}
              </span>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <h5
              className="mb-3 fw-bold text-secondary"
              style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}
            >
              ITEMS
            </h5>
            <Table
              responsive="md"
              hover
              style={{ fontSize: '0.9rem' }}
              className="border-top"
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  {columns.map((column) => (
                    <th
                      className="align-middle p-2"
                      key={column.key}
                      style={tableHeaderStyle}
                    >
                      <span>{column.label}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={columns.length} className="p-2 text-center">
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loading && data?.items?.length === 0 && (
                  <tr>
                    <td colSpan={columns.length} className="p-2 text-center">
                      No data
                    </td>
                  </tr>
                )}
                {!loading &&
                  data?.items?.length > 0 &&
                  data?.items?.map((item, indexStock) => (
                    <tr
                      key={indexStock}
                      style={{
                        borderBottom: '1px solid #dee2e6'
                      }}
                    >
                      {columns.map((column) => (
                        <td
                          key={column.key}
                          className="p-2 align-middle"
                          style={{
                            backgroundColor:
                              indexStock % 2 === 0 ? '#fff' : '#fcfcfc'
                          }}
                        >
                          {column.key === 'action' && renderAction(item)}
                          {column.component && column.component(item)}
                          {!column.component &&
                            column.key !== 'action' &&
                            item[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>

      <Card style={cardStyle}>
        <div
          className="d-flex justify-content-between align-items-center cursor-pointer mb-3"
          onClick={() => setExpand(!expand)}
          style={{ cursor: 'pointer' }}
        >
          <h5 className="m-0 fw-bold text-dark" style={{ fontSize: '1rem' }}>
            PROGRESS DETAIL
          </h5>
          <Button variant="transparent" className="p-0 text-secondary">
            {expand ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
          </Button>
        </div>

        <Collapse in={expand}>
          <div id="progress-collapse" className="mt-4 ms-3 position-relative">
            <div
              className="position-absolute"
              style={{
                top: '0',
                bottom: '0',
                left: '6px',
                borderLeft: '2px solid #e9ecef',
                zIndex: 0
              }}
            />
            {data?.progress?.length > 0 ? (
              data?.progress?.map((dataProgress, index) => (
                <div
                  key={index}
                  className="d-flex align-items-start mb-4 position-relative"
                  style={{ zIndex: 1 }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center bg-white"
                    style={{
                      width: '14px',
                      height: '14px',
                      borderRadius: '50%',
                      border: '2px solid var(--primary-orange)',
                      marginTop: '4px',
                      marginRight: '1rem',
                      flexShrink: 0
                    }}
                  >
                    <div
                      style={{
                        width: '6px',
                        height: '6px',
                        borderRadius: '50%',
                        backgroundColor: 'var(--primary-orange)'
                      }}
                    />
                  </div>
                  <div className="w-100">
                    <div
                      className="text-secondary small mb-1"
                      style={{ fontSize: '0.75rem', marginTop: '2px' }}
                    >
                      {dataProgress?.created_at || '-'}
                    </div>
                    <div
                      className="fw-bold text-dark"
                      style={{ fontSize: '0.9rem' }}
                    >
                      {dataProgress?.description}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="p-3 text-muted fst-italic">Data Empty!</div>
            )}
          </div>
        </Collapse>
      </Card>

      {/* TODO: SEND TO ERP */}
      {!data?.code_erp && data?.transfer_status === 'done' && (
        <Card style={cardStyle} className="mb-4">
          <div className="d-flex flex-row justify-content-between align-items-center">
            {data?.erp_histories && (
              <div className="d-flex flex-column">
                <div className="d-flex flex-column gap-1 justify-content-start fs-6">
                  <p className="mb-1">
                    Sent to ERP by{' '}
                    <strong>
                      {firstLetterUpperCase(data?.erp_histories?.user_name)}
                    </strong>{' '}
                    at {convertDateWithTime(data?.erp_histories?.submitted_at)},
                    status:
                    <span className="text-danger fw-bold ms-1">{` ${
                      data?.erp_histories?.status?.toUpperCase() || ''
                    }`}</span>
                  </p>
                  <p className="mb-0 text-muted">
                    Failed Reason: {data?.erp_histories?.response || ''}
                  </p>
                </div>
              </div>
            )}
            <div className="ms-auto">
              <Button
                className={`btn ${
                  loadingSendToErp ? 'btn-secondary' : 'btn-warning'
                } text-white fw-bold`}
                style={{ fontSize: '13px' }}
                disabled={loadingSendToErp}
                onClick={() => handleRetrySendToErp()}
              >
                {loadingSendToErp ? 'Sending...' : 'Send to ERP'}
              </Button>
            </div>
          </div>
        </Card>
      )}
      {/* END OF SEND TO ERP */}

      <Card style={cardStyle}>
        <Row>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Created By</span>
              <span style={valueStyle}>
                {data?.created_by
                  ? firstLetterUpperCase(data?.created_by)
                  : '-'}
              </span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Created At</span>
              <span style={valueStyle}>
                {data?.created_at && moment(data.created_at).isValid()
                  ? convertDateWithTime(data.created_at)
                  : '-'}
              </span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Last Updated By</span>
              <span style={valueStyle}>{data?.updated_by ?? '-'}</span>
            </div>
          </Col>
          <Col md={3}>
            <div className="d-flex flex-column">
              <span style={labelStyle}>Last Updated At</span>
              <span style={valueStyle}>
                {data?.updated_at && moment(data.updated_at).isValid()
                  ? convertDateWithTime(data.updated_at)
                  : '-'}
              </span>
            </div>
          </Col>
        </Row>
      </Card>
    </Container>
  )
}

export default DetailTransferArea
